import { apiPut, type ApiResponse } from "./genesisApi/httpsMethods";
import type {
  LeaseComp,
  LoanCompFromApi,
  SalesComp,
} from "../components/deal/DealCompSectionTypes";

export type DealCompsUpdateBody = {
  lease_comps: LeaseComp[];
  loan_comps: LoanCompFromApi[];
  sales_comps: SalesComp[];
};

export function buildDealCompsUrl(dealId: number): string {
  return `deal/${dealId}/comps`;
}

export async function updateDealComps(
  dealId: number,
  data: DealCompsUpdateBody,
): Promise<ApiResponse<unknown>> {
  return apiPut(buildDealCompsUrl(dealId), 0, { data }, true);
}
